// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { PlayerView, PlayerViewT } from '../tbs/player-view.js';


export class PlayerViewEnvelope implements flatbuffers.IUnpackableObject<PlayerViewEnvelopeT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PlayerViewEnvelope {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPlayerViewEnvelope(bb:flatbuffers.ByteBuffer, obj?:PlayerViewEnvelope):PlayerViewEnvelope {
  return (obj || new PlayerViewEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPlayerViewEnvelope(bb:flatbuffers.ByteBuffer, obj?:PlayerViewEnvelope):PlayerViewEnvelope {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PlayerViewEnvelope()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

view(obj?:PlayerView):PlayerView|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new PlayerView()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPlayerViewEnvelope(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addView(builder:flatbuffers.Builder, viewOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, viewOffset, 0);
}

static endPlayerViewEnvelope(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPlayerViewEnvelope(builder:flatbuffers.Builder, viewOffset:flatbuffers.Offset):flatbuffers.Offset {
  PlayerViewEnvelope.startPlayerViewEnvelope(builder);
  PlayerViewEnvelope.addView(builder, viewOffset);
  return PlayerViewEnvelope.endPlayerViewEnvelope(builder);
}

unpack(): PlayerViewEnvelopeT {
  return new PlayerViewEnvelopeT(
    (this.view() !== null ? this.view()!.unpack() : null)
  );
}


unpackTo(_o: PlayerViewEnvelopeT): void {
  _o.view = (this.view() !== null ? this.view()!.unpack() : null);
}
}

export class PlayerViewEnvelopeT implements flatbuffers.IGeneratedObject {
constructor(
  public view: PlayerViewT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const view = (this.view !== null ? this.view!.pack(builder) : 0);

  return PlayerViewEnvelope.createPlayerViewEnvelope(builder,
    view
  );
}
}
